import MultiMap from "../../../utilities/MultiMap.js";

export default class AmountSearchAdapter {
	setTransactions(transactions) {
		this.transactionList = new MultiMap();
		for(let transaction of transactions) {
			this.transactionList.set(transaction.amount, transaction.transaction);
		}
	}

	async search(query) {
		const amount = Number.parseInt(query);
		const result = this.transactionList.get(amount) || [];
		return result;
	}
}